import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import CreateCustomerDialog from "../../Customers/CreateCustomerDialog";

const filter = createFilterOptions();

const SelectCustomer = ({
  value,
  label = "Customer",
  onUpdate,
  disabled,
  enableAdd,
  onBlur,
  error,
  helperText,
  required,
  ...props
}) => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [customers, setCustomers] = useState([]);
  const [open, toggleOpen] = useState(false);
  const [dialogValue, setDialogValue] = useState("");

  const getCustomers = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/admin/customers`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status == 201) {
        setCustomers(response.data.customers);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDialogValue("");
    toggleOpen(false);
  };

  useEffect(() => {
    if (disabled) {
      setCustomers([]);
    } else {
      getCustomers();
    }
  }, [disabled]);

  return (
    <>
      <Autocomplete
        value={value}
        disabled={disabled}
        handleHomeEndKeys
        onChange={(event, newValue) => {
          // console.log("newValue", event, newValue);
          // When the user types then presses "enter" key
          if (enableAdd && typeof newValue === "string") {
            // timeout to avoid instant validation of the dialog's form.
            // console.log("Value is string");
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue(newValue.name);
            });
          }
          // When User types then clicks 'Add "inputText"'
          else if (enableAdd && newValue && !newValue.id) {
            // console.log("Value isnt string but no id");
            toggleOpen(true);
            setDialogValue(newValue.name);
          }
          // When User Selects and Option (Object) or Clicks the clear button (null)
          else {
            // console.log("Value is object or null", newValue);
            // console.log("SET VALUE", newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }
        }}
        onInputChange={() => {
          // console.log("onInputChange");
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (enableAdd && params.inputValue !== "") {
            filtered.push({
              id: undefined,
              name: params.inputValue,
            });
          }

          return filtered;
        }}
        options={customers}
        getOptionLabel={(option) => {
          //   console.log("Option", option);
          // for example value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.name;
        }}
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => {
          //  The "selected" prop on renderOption depends on this
          return value.name == option.name;
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;

          if (option.id)
            return (
              <li key={key} {...optionProps}>
                {option.name}
              </li>
            );
          else
            return (
              <li key={key} {...optionProps}>
                <Add style={{ marginRight: 8 }} />

                {option.id ? option.name : `Add "${option.name}"`}
              </li>
            );
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            size={props.size ? props.size : "small"}
            label={label}
            sx={{
              width: "100%",
            }}
            variant="outlined" // filled, outlined, standard
            InputProps={{
              ...params.InputProps,
              onKeyDown: (e) => {
                if (!enableAdd && e.key === "Enter") {
                  e.stopPropagation();
                }
              },
              endAdornment: <>{params.InputProps.endAdornment}</>,
            }}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
            required={required}
          />
        )}
      />

      <CreateCustomerDialog
        open={open}
        defaultCompanyName={dialogValue}
        handleClose={handleClose}
        onSuccess={async (newCustomer) => {
          // Refresh Data
          await getCustomers();
          // Set Created as Value
          onUpdate(newCustomer);
          // Close Dialog
          handleClose();
        }}
      />
    </>
  );
};

export default SelectCustomer;
